import styled from "styled-components";
import bg1 from "./assets/Graphics/bg1.png";

export const Container = styled.div`
  margin: 0 clamp(1px, 5vw, 100px);

  @media (max-width: 576px) {
    margin: 0 0.8em;
  }
`;

export const Hero = styled.div`
  display: flex;
  align-items: stretch; // Ensures both Content and ImageContainer have the same height
  justify-content: space-between;
  padding: 2rem;
  background-color: #f5f5ef;
  border-radius: 10px;
  height: 100%;
  /* margin: 0 clamp(1px, 5vw, 100px); */
  /* max-width: 900px; */
  /* margin: 0 auto; */
  @media (max-width: 768px) {
    padding: 1.5rem;
    flex-direction: column;
  }
`;

export const Content = styled.div`
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 1rem;
  @media (max-width: 768px) {
    padding: 1rem 0;
    padding-right: 0;
    margin-bottom: 1rem;
    order: 2; /* Ensure content appears after the image on mobile */
  }
`;

export const Title = styled.h1`
  /* font-size: clamp(22px, 2.2vw, 10em); */
  font-weight: bold;
  color: #273743;
  font-family: ${(props) =>
    props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};
`;

export const ImageContainer = styled.div`
  flex: 1 1 35%;
  border-radius: 10px;
  position: relative;
  object-fit: contain;
  justify-content: center;
  align-self: center;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Description = styled.p`
  font-size: 1rem;
  color: #4a4a4a;
  margin: 1rem 0;
`;

export const H3 = styled.h3`
  /* font-size: clamp(22px, 2.2vw, 10em);
  font-weight: bold;
  color: #273743;
  padding-top: 1em; */

  /* h3 { */
  /* align-self: center; */
  text-align: center;
  font-family: ${(props) =>
    props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};
  font-size: clamp(20px, 2.2vw, 5em);
  padding: 0.7em 0;
  /* text-transform: uppercase; */
  letter-spacing: -1px;

  background-image: url(${bg1});
  background-size: contain;
  /* background-size: auto; */
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  /* background-color: red; */
  text-align: center;
  margin: 1em auto;
  max-width: 14em;

  /* } */
`;
